import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
Vue.prototype.$axios = axios
import './plugins/element.js'
// import 'element-ui/lib/theme-chalk/index.css'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './assets/iconfont/iconfont.css'
// 引入全局样式
import './assets/css/global.css'
// 引入字体图标
import 'font-awesome/css/font-awesome.min.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './mixins/draggable.js'
import Blob from './excel/Blob.js';
import ExportExcel from './excel/ExportExcel.js';
// import keepScrollMixin from './mixins/keepScroll';
// Vue.use(keepScrollMixin, {
//   scroller: '#app-main-scroller'
// })
import GalaxyNumberInput from './components/input/GalaxyNumberInput.vue'
Vue.component('galaxy-number-input', GalaxyNumberInput)


import AFTableColumn from 'af-table-column'
const fontRate = {
  CHAR_RATE: 1.1, // 汉字比率
  NUM_RATE: 0.65, // 数字
  OTHER_RATE: 0.8 // 除汉字和数字以外的字符的比率
}
const fontSize = 15;
// 注册组件
Vue.use(AFTableColumn, { fontRate, fontSize })

// Vue.use(AFTableColumn)
import format from 'vue-text-format';
Vue.use(format);
Vue.use(ElementUI);

import Decimal from 'decimal.js';
Vue.prototype.$decimal = Decimal;
// const fontRate = {
//   CHAR_RATE: 1.1, // 汉字比率
//   NUM_RATE: 0.65, // 数字
//   OTHER_RATE: 0.8 // 除汉字和数字以外的字符的比率
// }
// const fontSize = 16
// Vue.use(AFTableColumn, { fontRate, fontSize })
// import {getColumnWidth} from './utils/getColumnWidth.js'
 
 
//el-table表格内容宽度自适应
// Vue.prototype.elTableAdaptationWidth = getColumnWidth
import copy from './directives/copy.js'; 
// 注册全局指令
Vue.directive('copy', copy);

Vue.config.productionTip = false
// Vue.use(ElementUI)
new Vue({
  router,
  store,  //store:store 和router一样，将创建的Vuex实例挂载到这个vue实例中
  render: h => h(App)
}).$mount('#app')


